export default __webpack_public_path__ + "images/referenzen/animationsfilm/edeka_10jahre_casefilm.mp4";